'use client';

import dynamic from 'next/dynamic';
import { ReactNode } from 'react';
import { User } from 'lucia';
import { VOD } from '@/lib/vodTypes';
import { PlayerSkeleton } from './PlayerSkeleton';

export interface VODPlayerDynamicProps {
  user: User | null;
  vod: VOD;
  chatSlot?: ReactNode;
}

const VODPlayer = dynamic(
  () => import('./VODPlayer').then(mod => mod.VODPlayer),
  {
    ssr: false,
    loading: () => <PlayerSkeleton />,
  },
);

export function VODPlayerDynamic({ user, vod, chatSlot }: Readonly<VODPlayerDynamicProps>) {
  return <VODPlayer user={user} vod={vod} chatSlot={chatSlot} />;
}
